import { createApp } from 'vue';

import App from '@/App.vue';

import { initializeMock } from '@/mocks';
import { initializeRouter } from '@/router';
import { initializePinia } from '@/stores';
import { initializeI18n } from '@/i18n';
import { initializeLaunchDarkly } from '@/analytics/launchDarkly';

import { MotionPlugin } from '@vueuse/motion';

import '@/assets/css/reset.css';
import '@/assets/css/global.css';
import '@/assets/css/animate.css';

initializeMock().then(() => {
  const app = createApp(App);

  initializePinia(app);
  initializeI18n(app);
  initializeRouter(app);
  initializeLaunchDarkly(app);

  app.use(MotionPlugin);

  app.mount('#app');
});
